import { colorsV2 } from '../../figma/colors-v2';
import * as React from 'react';
import styled from 'styled-components';
import { IconSystemV2EssentialClose } from '@doltech/icons/SystemV2/IconSystemV2EssentialClose';

const RemoveBox = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  display: grid;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${colorsV2.red10};
  right: 1px;
`;

interface RemoveItemProps {
  onRemove?: () => void;
}

export const RemoveItem = (props: RemoveItemProps) => {
  const { onRemove } = props;

  return (
    <RemoveBox
      className="remove-box"
      onClick={(e) => {
        e.stopPropagation();
        onRemove?.();
      }}
    >
      <IconSystemV2EssentialClose size={16} color={colorsV2.red100} />
    </RemoveBox>
  );
};
